/**
 * Helper class for managing responsive breakpoints
 * Provides utility methods for detecting viewport width changes relative to breakpoints
 *
 * @class BreakpointHelper
 */
class BreakpointHelper {
    /**
     * Check whether a passed breakpoint was crossed and in case
     * it was, if the screen's size is now above the breakpoint
     *
     * @param {number} breakpoint - The breakpoint width in pixels to check against
     * @param {boolean} aboveBreakpoint - Current state of whether we're above the breakpoint
     * @returns {{aboveBreakpoint: boolean, breakpointCrossed: boolean}} - Object containing updated state
     */
    static breakpointCrossed(breakpoint, aboveBreakpoint = false) {
        let breakpointCrossed = false;

        if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
            if (!aboveBreakpoint) {
                aboveBreakpoint = true;
                breakpointCrossed = true;
            }
            return { aboveBreakpoint, breakpointCrossed };
        }

        if (aboveBreakpoint) {
            aboveBreakpoint = false;
            breakpointCrossed = true;
        }

        return { aboveBreakpoint, breakpointCrossed };
    }

    /**
     * Returns if the screen's size is above a passed breakpoint
     *
     * @param {number} breakpoint - The breakpoint width in pixels to check against
     * @returns {boolean} - True if screen width is above the breakpoint, false otherwise
     */
    static aboveBreakpoint(breakpoint) {
        return window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
    }
}

export default BreakpointHelper;
